<script>
import { required } from "vuelidate/lib/validators";
import HR from "./form-components/HR.vue";
import gutter from "./form-components/gutter.vue";
import PatientAssistChat from "./form-components/PatientAssistChat.vue";
import PatientVoiceChat from "./form-components/PatientVoiceChat.vue";
import Heading from "./form-components/Heading.vue";
import TextInput from "./form-components/TextInput.vue";
import TextInputs from "./form-components/TextInputs.vue";
import ImagePreview from "./form-components/ImagePreview.vue";
import ExternalTextInput from "./form-components/ExternalTextInput.vue";
import SubgroupInput from "./form-components/SubgroupInput.vue";
import VariableListInput from "./form-components/VariableListInput.vue";
import ContentList from "./form-components/ContentList.vue";
import VariableListInputSingle from "./form-components/VariableListInputSingle.vue";
import SchedulerInput from "./form-components/SchedulerInput.vue";
import ContactInput from "./form-components/ContactInput.vue";
import SlugInput from "./form-components/SlugInput.vue";
import Preview from "./form-components/Preview.vue";
import RecommendedAppsPreview from "./form-components/RecommendedAppsPreview.vue";
import BannersPreview from "./form-components/BannersPreview.vue";
import OptionPreview from "./form-components/OptionPreview.vue";
import PracticeInfoPreview from "./form-components/PracticeInfoPreview.vue";
import ManagingConditionsPreview from "./form-components/ManagingConditionsPreview.vue";
import CreateGoogleMapBoundary from "./form-components/CreateGoogleMapBoundary.vue";
import NewMapBoundaryComponent from "./form-components/NewMapBoundaryComponent.vue";
import WebPreview from "./form-components/WebPreview.vue";
import TabletPreview from "./form-components/TabletPreview.vue";
import MobilePreview from "./form-components/MobilePreview.vue";
import HTDays from "./form-components/HTDays.vue";
import DateInput from "./form-components/DateInput.vue";
import TimeSelectInput from "./form-components/TimeSelectInput.vue";
import ToggleInput from "./form-components/ToggleInput.vue";
import SelectInput from "./form-components/SelectInput.vue";
import SelectInputObject from "./form-components/SelectInputObject.vue";
import NewsSelectInput from "./partials/NewsSelectInput.vue";
import QuestionSelectInput from "./partials/QuestionSelectInput.vue";
import ImgSelectInput from "./partials/ImgSelectInput.vue";
import PdfSelectInput from "./partials/PdfSelectInput.vue";
import ImgSelectInputHide from "./partials/ImgSelectInputHide.vue";
import IconSelectInput from "./partials/IconSelectInput.vue";
import VidTextInput from "./form-components/VidTextInput.vue";
import GroupSelectInput from "./partials/GroupSelectInput.vue";
import GroupSelectClinicsInput from "./partials/GroupSelectClinicsInput.vue";
import FooterGroupSelectInput from "./partials/FooterGroupSelectInput.vue";
import REGroupSelectInput from "./partials/REGroupSelectInput.vue";
import OnlineGroup from "./partials/OnlineGroup.vue"
import SubGroupSelectInput from "./partials/SubGroupSelectInput.vue";
import LocationSelectInput from "./partials/LocationSelectInput.vue";
import LocationMultiSelectInput from "./partials/LocationMultiSelectInput.vue";
import PracticeMultiSelectInput from "./partials/PracticeMultiSelectInput.vue";
import RadioInput from "./form-components/RadioInput.vue";
import AlertInput from "./form-components/AlertInput.vue";
import CheckObjectInput from "./form-components/CheckObjectInput.vue";
import MailSettingsCheckboxInput from "./form-components/MailSettingsCheckboxInput.vue";
import CheckObjectMultiInput from "./form-components/CheckObjectMultiInput.vue";
import CheckObjectMultiLocInput from "./form-components/CheckObjectMultiLocInput.vue";
import CheckObjectMultiLocPlacesInput from "./form-components/CheckObjectMultiLocPlacesInput.vue";
import SelectObjectMultiLocPlacesInput from "./form-components/SelectObjectMultiLocPlacesInput.vue";
import CheckObjectMultiOptionsInput from "./form-components/CheckObjectMultiOptionsInput.vue";
import CheckObjectMultiAilmentsInput from "./form-components/CheckObjectMultiAilmentsInput.vue";
import StaffInput from "./form-components/StaffInput.vue";
import RadioObjectInput from "./form-components/RadioObjectInput.vue";
import RadioObjectwithImgInput from "./form-components/RadioObjectwithImgInput.vue";
import CheckboxInput from "./form-components/CheckboxInput.vue";
import CkEditor from "./form-components/CKEditorInput.vue";
import ImageIcon from "./form-components/ImageIcon.vue";
import FooterImageIcon from "./form-components/FooterImageIcon.vue";
import ManageConditionPreview from "./form-components/ManageConditionPreview.vue";
import OnlineFormsPreview from "./form-components/OnlineFormsPreview.vue";
import PatientVoiceUpload from "./form-components/PatientVoiceUpload.vue";

const FormSections = () => import("./form-components/FormSections.vue");

import _ from "lodash";

export default {
  name: "Form",
  components: {
    ManageConditionPreview,
    OnlineFormsPreview,
    TextInput,
    TextInputs,
    ImagePreview,
    CkEditor,
    DateInput,
    ToggleInput,
    SlugInput,
    CheckboxInput,
    SelectInput,
    SelectInputObject,
    RadioInput,
    AlertInput,
    NewsSelectInput,
    RadioObjectInput,
    RadioObjectwithImgInput,
    GroupSelectInput,
    FooterGroupSelectInput,
    REGroupSelectInput,
    OnlineGroup,
    SubGroupSelectInput,
    LocationSelectInput,
    TimeSelectInput,
    CheckObjectInput,
    LocationMultiSelectInput,
    PracticeMultiSelectInput,
    SubgroupInput,
    ImgSelectInput,
    IconSelectInput,
    VidTextInput,
    Preview,
    HTDays,
    VariableListInput,
    WebPreview,
    TabletPreview,
    MobilePreview,
    HR,
    gutter,
    CheckObjectMultiInput,
    CheckObjectMultiLocInput,
    StaffInput,
    ImgSelectInputHide,
    ExternalTextInput,
    CheckObjectMultiLocPlacesInput,
    OptionPreview,
    QuestionSelectInput,
    CheckObjectMultiOptionsInput,
    CheckObjectMultiAilmentsInput,
    RecommendedAppsPreview,
    GroupSelectClinicsInput,
    BannersPreview,
    SelectObjectMultiLocPlacesInput,
    ImageIcon,
    MailSettingsCheckboxInput,
    Heading,
    PdfSelectInput,
    FooterImageIcon,
    PracticeInfoPreview,
    CreateGoogleMapBoundary,
    NewMapBoundaryComponent,
    PatientAssistChat,
    PatientVoiceChat,
    ManagingConditionsPreview,
    VariableListInputSingle,
    SchedulerInput,
    ContactInput,
    FormSections,
    PatientVoiceUpload,
    ContentList,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    topbarControls: {
      type: Object,
      required: false,
    },
    selectedItem: {
      type: Object,
      required: false,
    },
    setSelectedItems: {
      type: Function,
      required: false,
    },
    updateSelectedItem: {
      type: Function,
      required: false,
    },
    closeModal: {
      type: Function,
      required: false,
    },
    variant: {
      type: String,
      required: true,
    },
    rules: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    categoryName() {
      return this.$route?.params?.categoryName
        ? this.$route.params.categoryName
        : "";
    },
    formObject() {
      let { data, form } = this;
      if (this.isConatinFormLayout(form)) {
        if (data?.form_layout && form[data.form_layout]) {
          return form[data.form_layout];
        } else {
          return this.getFirstProperty(form);
        }
      }
      return form;
    },
  },
  data() {
    return {
      submitted: false,
      last_updated: {},
    };
  },
  mounted() {
    // Check and set the disabled state for description fields on component mount
    // Use nextTick to ensure data is ready
    this.$nextTick(() => {
      this.checkAndSetDescriptionFieldsDisabledState();
    });
  },
  watch: {
    data: {
      handler: function (val) {
        if (Object.keys(val).length) {
          // Check and set the disabled state when data changes
          // Use nextTick to ensure DOM is updated
          this.$nextTick(() => {
            this.checkAndSetDescriptionFieldsDisabledState();
          });
          for (let key of Object.keys(this.$v.data.$params)) {
            if (!(key in val)) {
              if (this.formObject[key].inside) {
                let inside = this.formObject[key].inside;
                let value = _.get(this.data, inside);
                if (value) {
                  val.additionalProp1[key] = value;
                  this.$v.data[key].$model = value;
                } else {
                  _.set(val, inside, "");
                  this.$v.data[key].$model = "";
                }
              } else if (val.additionalProp1 && key in val.additionalProp1) {
                val[key] = val.additionalProp1[key];
              } else if (val.additionalProp && !(key in val.additionalProp1)) {
                val.additionalProp1[key] = "";
                this.$v.data[key].$model = "";
              }
            }
          }
        }
        return val;
      },
      deep: true,
    },
  },
  validations() {
    let validations = new Object();
    validations.data = new Object();
    for (const [key, value] of Object.entries(this.formObject)) {
      if (value.required) {
        validations.data[key] = { required };
      } else {
        validations.data[key] = {};
      }
    }
    return validations;
  },
  methods: {
    checkAndSetDescriptionFieldsDisabledState() {
      // Check if we're on the sick/fitnotes page
      if (
        this.$route?.params?.categoryName === "sick/fitnotes" ||
        this.$route?.params?.categoryName === "sick/fitnotesicb"
      ) {
        // Check if the form type is Online Form
        const formType = this.data["sick_fit_notes_form_type"];
        const isOnlineForm = formType === "Online Form";
        
        // If Online Form, also set the toggle to false
        if (isOnlineForm && this.data["how_long_off_work_toggle"] !== false) {
          this.$set(this.data, "how_long_off_work_toggle", false);
        }

        // Update the disabled state in the form
        const formToUpdate = this.formObject;
        if (formToUpdate) {
          // Check at the root level
          Object.keys(formToUpdate).forEach((fieldKey) => {
            if (
              fieldKey === "how_long_off_work_toggle" ||
              fieldKey === "seven_days_or_less_description" ||
              fieldKey === "more_than_seven_days_description"
            ) {
              this.$set(formToUpdate[fieldKey], "disabled", isOnlineForm);
            }
          });

          // Check inside formSections
          Object.keys(this.form).forEach((fieldKey) => {
            const field = this.form[fieldKey];
            if (field && field.type === "formSection" && field.components) {
              Object.keys(field.components).forEach((componentKey) => {
                if (
                  componentKey === "how_long_off_work_toggle" ||
                  componentKey === "seven_days_or_less_description" ||
                  componentKey === "more_than_seven_days_description"
                ) {
                  this.$set(
                    field.components[componentKey],
                    "disabled",
                    isOnlineForm
                  );
                }
              });
            }
          });

          // Specifically check the how_long_off_work_section
          if (
            this.form["how_long_off_work_section"] &&
            this.form["how_long_off_work_section"].components
          ) {
            const section = this.form["how_long_off_work_section"].components;
            if (section["how_long_off_work_toggle"]) {
              this.$set(
                section["how_long_off_work_toggle"],
                "disabled",
                isOnlineForm
              );
            }
            if (section["seven_days_or_less_description"]) {
              this.$set(
                section["seven_days_or_less_description"],
                "disabled",
                isOnlineForm
              );
            }
            if (section["more_than_seven_days_description"]) {
              this.$set(
                section["more_than_seven_days_description"],
                "disabled",
                isOnlineForm
              );
            }
          }

          // Check if form has nested layouts
          Object.keys(this.form).forEach((layoutKey) => {
            if (
              typeof this.form[layoutKey] === "object" &&
              !this.form[layoutKey].type
            ) {
              Object.keys(this.form[layoutKey]).forEach((fieldKey) => {
                if (
                  fieldKey === "how_long_off_work_toggle" ||
                  fieldKey === "seven_days_or_less_description" ||
                  fieldKey === "more_than_seven_days_description"
                ) {
                  this.$set(
                    this.form[layoutKey][fieldKey],
                    "disabled",
                    isOnlineForm
                  );
                }
              });
            }
          });

          // Force update
          this.$forceUpdate();
        }
      }
    },
    displayLogic(item) {
      if (this.categoryName === "openinghours") {
        return true; // omiting the display logic for openinghours bcs status value is array not on object
      }
      let { selectedItem } = this;
      let showComponent = true;
      if (!selectedItem) {
        return showComponent;
      }
      if (
        item.displayOn &&
        item.displayOnValue &&
        selectedItem[item.displayOn] !== undefined
      ) {
        let value = "";
        if (typeof selectedItem[item.displayOn] === "object") {
          value = selectedItem[item.displayOn]?.name || "";
        } else {
          value = this.isValidJSON(selectedItem[item.displayOn])
            ? JSON.stringify(selectedItem[item.displayOn])
            : selectedItem[item.displayOn];
        }

        let value2 = this.isStringContainObject(item.displayOnValue)
          ? this.getObjectValue(item.displayOnValue)
          : item.displayOnValue;
        if (value !== value2) {
          showComponent = false;
        }
      }
      return showComponent;
    },
    isStringContainObject(jsonString) {
      if (typeof jsonString === "boolean") {
        return false;
      } else if (typeof jsonString === "object") {
        return false;
      }
      if (
        jsonString.includes("{") &&
        jsonString.includes("}") &&
        jsonString.includes("name")
      ) {
        return true;
      }
      return false;
    },
    getObjectValue(jsonString) {
      let val1 = JSON.parse(jsonString);
      return val1.name || "";
    },
    isValidJSON(jsonString) {
      // Check if the string contains both "{" and "}" characters
      if (typeof jsonString === "boolean") {
        return true;
      } else if (typeof jsonString === "object") {
        return true;
      }
      if (jsonString.includes("{") && jsonString.includes("}")) {
        try {
          JSON.parse(jsonString);
          return true; // The string is valid JSON
        } catch (error) {
          return false; // The string is not valid JSON
        }
      } else {
        return false; // The string does not contain necessary JSON characters
      }
    },
    saveAndClose(data) {
      delete this.data.patientvoiceupload;
      Object.assign(this.data, data);
      console.log("close dialog method called", this.data);
      if (this.closeModal) this.closeModal();
      this.topbarControls.onAddFn(this.data);
    },
    closeDialog() {
      console.log("close dialog method called");
      if (this.closeModal) this.closeModal();
    },
    isConatinFormLayout(obj) {
      for (let key in obj) {
        if (
          Object.prototype.hasOwnProperty.call(obj, key) &&
          key.startsWith("layout_")
        ) {
          return obj[key]; // Return the value of the first 'layout_' key found
        }
      }
      return false; // Return false if no 'layout_' key is found
    },
    getFirstProperty(obj) {
      // Get all the keys of the object
      const keys = Object.keys(obj);

      // Check if the object is not empty
      if (keys.length === 0) {
        return null; // or undefined, or any other value you prefer
      }

      // Return the value of the first property
      return obj[keys[0]];
    },
    // eslint-disable-next-line no-unused-vars
    async formSubmit(e) {
      this.submitted = true;
      // stop here if form is invalid
      // await this.$v.$touch();
      switch (this.variant) {
        case "add":
          this.topbarControls.onAddFn(this.data);
          break;
        case "patch":
          if (this.isValidationPassed()) {
            this.topbarControls.onSubmitFn(this.data, this.formObject);
          }
          break;
      }
      if (this.closeModal) this.closeModal();
    },
    isValidationPassed() {
      let validation = true;
      if (this.$refs["schedulerinput"] && this.$refs["schedulerinput"].length) {
        this.$refs["schedulerinput"].every((inputComponent) => {
          validation = inputComponent.validate();
        });
      }
      return validation;
    },
    updateValue(key, val) {
      this.last_updated = {
        key: key,
        value: val,
      };
      this.data[key] = val;

      // Disable description fields when Online Form is selected for Sick/Fit Notes
      if (
        this.$route?.params?.categoryName === "sick/fitnotes" ||
        this.$route?.params?.categoryName === "sick/fitnotesicb"
      ) {
        if (key === "sick_fit_notes_form_type") {
          const isOnlineForm = val === "Online Form";

          // Set how_long_off_work_toggle to false when Online Form is selected
          if (isOnlineForm) {
            this.data["how_long_off_work_toggle"] = false;
          }

          // Since formObject is a computed property, we need to update the underlying form prop
          // Update the form prop directly which will reflect in formObject
          if (this.form) {
            // Check at the root level
            Object.keys(this.form).forEach((fieldKey) => {
              if (
                fieldKey === "how_long_off_work_toggle" ||
                fieldKey === "seven_days_or_less_description" ||
                fieldKey === "more_than_seven_days_description"
              ) {
                console.log("isOnlineForm", isOnlineForm);
                this.$set(this.form[fieldKey], "disabled", isOnlineForm);
              }
            });

            // Check inside formSections
            Object.keys(this.form).forEach((fieldKey) => {
              const field = this.form[fieldKey];
              if (field && field.type === "formSection" && field.components) {
                Object.keys(field.components).forEach((componentKey) => {
                  if (
                    componentKey === "how_long_off_work_toggle" ||
                    componentKey === "seven_days_or_less_description" ||
                    componentKey === "more_than_seven_days_description"
                  ) {
                    this.$set(
                      field.components[componentKey],
                      "disabled",
                      isOnlineForm
                    );
                  }
                });
              }
            });

            // Specifically check the how_long_off_work_section
            if (
              this.form["how_long_off_work_section"] &&
              this.form["how_long_off_work_section"].components
            ) {
              const section = this.form["how_long_off_work_section"].components;
              if (section["how_long_off_work_toggle"]) {
                this.$set(
                  section["how_long_off_work_toggle"],
                  "disabled",
                  isOnlineForm
                );
              }
              if (section["seven_days_or_less_description"]) {
                this.$set(
                  section["seven_days_or_less_description"],
                  "disabled",
                  isOnlineForm
                );
              }
              if (section["more_than_seven_days_description"]) {
                this.$set(
                  section["more_than_seven_days_description"],
                  "disabled",
                  isOnlineForm
                );
              }
            }

            // Check if form has nested layouts (for form_layout)
            Object.keys(this.form).forEach((layoutKey) => {
              if (
                typeof this.form[layoutKey] === "object" &&
                !this.form[layoutKey].type
              ) {
                // This could be a layout object containing form fields
                Object.keys(this.form[layoutKey]).forEach((fieldKey) => {
                  if (
                    fieldKey === "how_long_off_work_toggle" ||
                    fieldKey === "seven_days_or_less_description" ||
                    fieldKey === "more_than_seven_days_description"
                  ) {
                    this.$set(
                      this.form[layoutKey][fieldKey],
                      "disabled",
                      isOnlineForm
                    );
                  }
                });
              }
            });
          }

          // Force Vue to re-render the component
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        }
      }

      // this.updateSelectedItem(this.data);
      // this.selectedItem[key] = val;
      this.applyFormRules(this.data, this.rules);
    },
    applyFormRules(formData, rules) {
      // Check the condition in the rule
      if (
        formData &&
        rules?.condition &&
        formData[rules.condition.key] === rules.condition.value
      ) {
        // Apply each action in the rule if condition is met
        rules.actions.forEach((action) => {
          if (action.actionType === "CHANGE_VALUE") {
            this.$nextTick(() => {
              formData[action.targetKey] = action.newValue;
            });
          }
        });
      }
      return formData;
    },
  },
};
</script>
<template>
  <form
    v-if="data"
    class="needs-validation form-container"
    @submit.prevent="formSubmit"
  >
    <div class="row">
      <!-- :class="`col-${item.size} ${item.class} ${!item.display ? '' : 'd-none'}`" -->
      <template v-for="(item, key) in formObject">
        <div
          v-if="displayLogic(item, key)"
          class="form-group mb-0"
          :key="item.label"
          :class="`col-${item.size} ${item.class}`"
        >
          <FormSections
            v-if="
              item.type == 'formSection' &&
              item.components &&
              Object.entries(data).length
            "
            :item_key="key"
            :item_value="data[key]"
            :data="data"
            :item="item"
            :form="item.components"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :validation_data="$v.data"
            :vmodel="$v.data[key].$model"
            :last_updated="last_updated"
            :updateValue="updateValue"
          >
          </FormSections>
          <PatientAssistChat
            v-if="
              item.type == 'patientAssistChat' && Object.entries(data).length
            "
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <PatientVoiceChat
            v-if="
              item.type == 'patientVoiceChat' && Object.entries(data).length
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <PatientVoiceUpload
            v-if="
              item.type == 'patientvoiceupload' && Object.entries(data).length
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
            @closeDialog="closeDialog"
            @saveandclose="saveAndClose"
          >
          </PatientVoiceUpload>
          <HR
            v-if="item.type == 'hr' && Object.entries(data).length"
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <gutter
            v-if="item.type == 'gutter' && Object.entries(data).length"
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />

          <Heading
            v-if="item.type == 'heading' && Object.entries(data).length"
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <ImageIcon
            v-if="item.type == 'image' && Object.entries(data).length"
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <FooterImageIcon
            v-if="item.type == 'footerImage' && Object.entries(data).length"
            :item="item"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <TextInput
            v-if="item.type == 'text' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <TextInputs
            v-if="item.type == 'textinputs' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <ImagePreview
            v-if="item.type == 'imgPreview' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <ExternalTextInput
            v-if="
              item.type == 'externalText' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <VidTextInput
            v-if="item.type == 'vidText' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <ImgSelectInput
            v-if="item.type == 'imgSelect' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <PdfSelectInput
            v-if="item.type == 'pdfSelect' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <ImgSelectInputHide
            v-if="
              item.type == 'imgSelectHide' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <IconSelectInput
            v-if="item.type == 'iconSelect' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <SubgroupInput
            v-if="item.type == 'subgroup' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <StaffInput
            v-if="item.type == 'stafflist' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <VariableListInput
            v-if="
              item.type == 'variableList' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <ContentList
            v-if="
              item.type == 'contentlist' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <VariableListInputSingle
            v-if="
              item.type == 'variableListSingle' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <SchedulerInput
            v-if="
              item.type == 'schedulerinput' && $v.data[key].$model != undefined
            "
            :ref="item.type"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <ContactInput
            v-if="
              item.type == 'contactinput' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />

          <SlugInput
            v-if="item.type == 'slug' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <Preview
            v-if="item.type == 'preview'"
            :item="item"
            :selectedItem="selectedItem"
          />
          <RecommendedAppsPreview
            v-if="item.type == 'recommendedAppsPreview'"
            :item="item"
            :selectedItem="selectedItem"
          />
          <BannersPreview
            v-if="item.type == 'bannersPreview'"
            :item="item"
            :selectedItem="selectedItem"
            :updateValue="updateValue"
            :last_updated="last_updated"
          />
          <OptionPreview
            v-if="item.type == 'optionPreview' && selectedItem.id"
            :item="item"
            :selectedItem="selectedItem"
          />
          <PracticeInfoPreview
            v-if="item.type == 'practiceInfoPreview' && selectedItem.id"
            :item="item"
            :selectedItem="selectedItem"
            :updateValue="updateValue"
          />
          <ManageConditionPreview
            v-if="item.type == 'ManageConditionPreview' && selectedItem.id"
            :item="item"
            :selectedItem="selectedItem"
            :updateValue="updateValue"
          >
          </ManageConditionPreview>
          <OnlineFormsPreview
            v-if="item.type == 'OnlineFormsPreview' && selectedItem.id"
            :item="item"
            :selectedItem="selectedItem"
            :updateValue="updateValue"
          >
          </OnlineFormsPreview>
          <ManagingConditionsPreview
            v-if="item.type == 'managingConditionsPreview' && selectedItem.id"
            :item="item"
            :selectedItem="selectedItem"
          />
          <CreateGoogleMapBoundary
            v-if="
              item.type == 'createGoogleMapBoundary' &&
              $v.data[key].$model != undefined
            "
            :item="item"
            :selectedItem="selectedItem"
            :item_key="key"
            :item_value="data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
          />
          <NewMapBoundaryComponent
            v-if="
              item.type == 'mapboundary' && $v.data[key].$model != undefined
            "
            :item="item"
            :selectedItem="selectedItem"
            :item_key="key"
            :item_value="data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
          />
          <WebPreview
            v-if="item.type == 'webPreview'"
            :item="item"
            :selectedItem="selectedItem"
          />
          <TabletPreview
            v-if="item.type == 'tabletPreview'"
            :item="item"
            :selectedItem="selectedItem"
          />
          <MobilePreview
            v-if="item.type == 'mobilePreview'"
            :item="item"
            :selectedItem="selectedItem"
          />
          <HTDays
            v-if="item.type == 'ht_days'"
            :item="item"
            :selectedItem="selectedItem"
            :item_key="key"
            :item_value="data[key]"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :updateValue="updateValue"
          />
          <TimeSelectInput
            v-if="item.type == 'time' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :last_updated="last_updated"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :updateValue="updateValue"
          />
          <DateInput
            v-if="item.type == 'date' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <CheckboxInput
            v-if="item.type == 'checkbox' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
          />
          <MailSettingsCheckboxInput
            v-if="
              item.type == 'mailSettingsCheckbox' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
          />
          <SelectInput
            v-if="item.type == 'select' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <SelectInputObject
            v-if="
              item.type == 'selectObject' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <SubGroupSelectInput
            v-if="
              item.type == 'subgroupSelect' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <GroupSelectInput
            v-if="
              item.type == 'groupSelect' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <GroupSelectClinicsInput
            v-if="
              item.type == 'groupSelectClinics' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <FooterGroupSelectInput
            v-if="item.type == 'footerGroupSelect'"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <REGroupSelectInput
            v-if="item.type == 'reGroupSelect'"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
           <OnlineGroup
            v-if="item.type == 'onlineGroupSelect'"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          
          <LocationSelectInput
            v-if="
              item.type == 'locationSelect' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <LocationMultiSelectInput
            v-if="
              item.type == 'locationMultiSelect' &&
              $v.data[key].$model != undefined &&
              selectedItem.additionalProp1.locations
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <PracticeMultiSelectInput
            v-if="
              item.type == 'practiceMultiSelect' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <NewsSelectInput
            v-if="item.type == 'newsSelect' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <QuestionSelectInput
            v-if="
              item.type == 'questionSelect' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
            :topbarControls="topbarControls"
            :updateValue="updateValue"
          />
          <CheckObjectInput
            v-if="
              item.type == 'checkObject' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <CheckObjectMultiInput
            v-if="
              item.type == 'checkObjectMulti' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
          />
          <CheckObjectMultiLocInput
            v-if="
              item.type == 'checkObjectMultiLoc' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
          />
          <CheckObjectMultiLocPlacesInput
            v-if="
              item.type == 'checkObjectMultiLocPlaces' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
          />
          <SelectObjectMultiLocPlacesInput
            v-if="
              item.type == 'selectObjectMultiLocPlaces' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
          />
          <CheckObjectMultiOptionsInput
            v-if="
              item.type == 'checkObjectMultiOptions' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
          />
          <CheckObjectMultiAilmentsInput
            v-if="
              item.type == 'checkObjectMultiAilments' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
            :selectedItem="selectedItem"
          />
          <RadioObjectInput
            v-if="
              item.type == 'radioObject' && $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <RadioObjectwithImgInput
            v-if="
              item.type == 'radioObjectwithImg' &&
              $v.data[key].$model != undefined
            "
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <RadioInput
            v-if="item.type == 'radio' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <AlertInput
            v-if="item.type == 'alertinput' && $v.data[key].$model != undefined"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
          />
          <ToggleInput
            v-if="item.type == 'toggle' && $v.data[key].$model != undefined"
            :key="`toggle-${key}-${data.sick_fit_notes_form_type || 'default'}-${item.disabled}`"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :selectedItem="selectedItem"
            :last_updated="last_updated"
          />
          <CkEditor
            v-if="item.type == 'ckeditor' && $v.data[key].$model != undefined"
            :key="`ckeditor-${key}-${item.disabled}`"
            :item_key="key"
            :item_value="data[key]"
            :item="item"
            :submitted="submitted"
            :selectedItem="selectedItem"
            :validation="$v.data[key]"
            :updateValue="updateValue"
            :last_updated="last_updated"
          />
        </div>
      </template>
    </div>
    <!-- will coorect the logic later -->
    <button
      v-if="
        Object.entries(data).length &&
        !['landingpage'].includes(categoryName) &&
        this.variant === 'patch'
      "
      class="btn btn-primary mt-3 px-4 mb-5"
      type="submit"
      style="border-radius: 0"
    >
      SAVE
    </button>
    <button
      v-if="
        Object.entries(data).length &&
        ['landingpage'].includes(categoryName) &&
        this.variant === 'patch' &&
        data.title === 'Featured News'
      "
      class="btn btn-primary mt-3 px-4 mb-5"
      type="submit"
      style="border-radius: 0"
    >
      SAVE
    </button>
    <button
      v-if="
        Object.entries(data).length &&
        !['landingpage', 'patientvoice'].includes(categoryName) &&
        this.variant === 'add'
      "
      class="btn btn-primary mt-3 px-4 mb-5"
      type="submit"
      style="border-radius: 0"
    >
      SAVE
    </button>
  </form>
</template>
<style>
.form-container {
}
.add-scroll {
  /* overflow: hidden !important; */
}
.custom-scrollbar {
  scrollbar-width: thin; /* For Firefox */
  scrollbar-color: #005eb8 #e0e0e0; /* For Firefox: thumb and track color */

  /* Additional styles for ensuring visibility */
  overflow-y: scroll; /* Force showing the scrollbar */
}

.custom-scrollbar::-webkit-scrollbar {
  width: 8px; /* Width of the scrollbar */
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background-color: #005eb8; /* Color of the thumb */
  border-radius: 10px; /* Border radius of the thumb */
  border: 3px solid #e0e0e0; /* Makes the thumb stand out more from the track */
}

.custom-scrollbar::-webkit-scrollbar-track {
  background-color: #e0e0e0; /* Color of the track */
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); /* Adds shadow to the track for better visibility */
}
</style>
